webpackJsonp([117628133359505],{

/***/ 816:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"dakar","www_url":"http://www.i-love-u.ch","thema":"paris","issue_month":"February","issue_year":2006,"issue_date":200602,"artist":"luzora","location":"Schweiz","email":"luzora@hotmail.com","id":"contribution_175","media_type":"textz","position_in_section":1,"media_uri":"media/2006/February/textz/dakar.gif","media_th_uri":"media/2006/February/textz/tn_dakar.gif","still_image_count":0,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_175"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200602-textz-1-42b39038112ed8248a1f.js